var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VPopover',{attrs:{"trigger":"hover click focus"}},[_vm._t("trigger"),_vm._t("popover",null,{"slot":"popover"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }